import React, { forwardRef } from 'react';
import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';
function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
interface CardProps extends React.HTMLAttributes<HTMLDivElement> {
  variant?: 'default' | 'hover';
}
export const Card = forwardRef<HTMLDivElement, CardProps>(({
  className,
  variant = 'default',
  ...props
}, ref) => {
  return <div ref={ref} className={cn('rounded-xl border bg-card text-card-foreground shadow-sm', variant === 'hover' && 'transition-all duration-300 hover:shadow-lg hover:-translate-y-1 hover:border-gold/50', className)} {...props} data-id="element-148" />;
});
Card.displayName = 'Card';